module.exports = __webpack_public_path__ + "img/25.81349cd7.jpg";